module.exports = __webpack_public_path__ + "img/right.2d0c84e3.svg";